enum productTypeEnum {
  ONE_ITEM = 'Regular Item',
  PACKAGE = 'Foody Bag',
}

export default productTypeEnum
